<template>
  <div>
    <el-dialog
      top="10vh"
      width="455px"
      center
      title="充值"
      :visible.sync="topupDialogVisible"
      @close="HandleCancel"
    >
      <el-form :rules="rules" :model="data" :ref="form" label-width="110px">
        <el-form-item prop="bankId" label="提现卡">
          <el-select style="width: 230px" v-model="data.bankId">
            <el-option
              v-for="option in withdrawOptions"
              :key="option.value"
              :label="option.label"
              :value="option.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="已选银行卡">
          {{ this.HandleGetState(this.modules, "bankCardNumber") }} ({{
            this.HandleGetState(this.modules, "bankName")
          }})
        </el-form-item>
        <el-form-item label="金额">
          <el-input-number v-model="data.amount" :min="0"> </el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button round @click="HandleCancel"> 取消 </el-button>
        <el-button :loading="loading" round type="success" @click="HandleVaild">
          保存
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import mainCommon from "@/utils/mainCommon";
import varCommon from "@/utils/varCommon";
import { getWithdrawBankList, withdrawBalance } from "@/api/withdraw";

export default {
  mixins: [mainCommon],
  props: ["modules"],
  data() {
    return {
      loading: false,
      form: "form",
      rules: {
        bankId: [{ required: true, message: "必填项目不可为空" }],
      },
      data: {
        amount: null,
        accId: null,
        bankId: null,
      },
      withdrawOptions: [],
    };
  },
  computed: {
    topupDialogVisible: {
      get() {
        if (this.$store.state[this.modules].topupDialogVisible) {
          this.HandleWithdrawBankList();
          return this.$store.state[this.modules].topupDialogVisible;
        }
      },
      set(val) {
        this.HandleSetState(this.modules, "/SET_STATE", {
          topupDialogVisible: val,
        });
      },
    },
  },
  methods: {
    HandleWithdrawBankList() {
      getWithdrawBankList({
        pageSize: varCommon.pagination.pageSizeNoLimit,
        pageNum: 1,
      }).then((res) => {
        this.withdrawOptions = res.data.list.map((res) => {
          return { label: `${res.bankNo} (${res.bankName})`, value: res.id };
        });
      });
    },
    HandleCancel() {
      this.$refs[this.form].resetFields();
      this.$store.commit(`${this.modules}/SET_DEFAULT`);
      this.HandleSetState(this.modules, "/SET_STATE", {
        topupDialogVisible: false,
      });
    },
    HandleVaild() {
      this.$refs[this.form].validate((valid) => {
        if (valid) this.HandleSubmit();
      });
    },
    HandleSubmit() {
      this.loading = true;
      this.data.accId = this.HandleGetState(this.modules, "id");
      withdrawBalance(this.data)
        .then((res) => {
          this.$notify.success("提交充值订单成功！");
          this.HandleCancel();
          this.$emit("HandleGetList");
        })
        .catch((err) => {})
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/views/account/bank/TopupDialog.vue